module.exports = __webpack_public_path__ + "fonts/Raleway-Black.5bea5047.ttf";